var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStateDrawer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 69,
    viewBox: "0 0 62 69",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.40027 32.9V14.3784C5.40027 12.26 5.40027 11.2008 5.57627 10.3208C6.36027 6.436 9.59867 3.396 13.7427 2.6664C14.6803 2.5 15.8131 2.5 18.0723 2.5C19.0643 2.5 19.5571 2.5 20.0307 2.5416C22.0819 2.7208 24.0307 3.476 25.6147 4.708C26.105 5.11119 26.578 5.53504 27.0323 5.9784L28.4403 7.3C30.5299 9.2584 31.5731 10.2376 32.8243 10.8904C33.5133 11.2488 34.2365 11.5293 34.9939 11.732C36.3699 12.1 37.8483 12.1 40.8019 12.1H41.7587C48.4979 12.1 51.8643 12.1 54.0563 13.9464C54.2589 14.1171 54.4509 14.2963 54.6323 14.484C56.6003 16.5384 56.6003 19.7 56.6003 26.0136V32.9",
    stroke: "#D5DEE5",
    strokeWidth: 3.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6002 50.5H37.4002",
    stroke: "#D5DEE5",
    strokeWidth: 3.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72657 52.0488C2.20017 43.3576 1.43217 39.012 3.28497 35.8856C3.7607 35.0835 4.3367 34.3688 5.01297 33.7416C7.65297 31.3 11.9218 31.3 20.4562 31.3H41.5442C50.0786 31.3 54.3442 31.3 56.9874 33.7416C57.6615 34.3688 58.2375 35.0835 58.7154 35.8856C60.565 39.012 59.8034 43.3576 58.2738 52.0456C57.1762 58.3048 56.6258 61.4344 54.7218 63.508C54.2282 64.0437 53.6753 64.5214 53.0738 64.932C50.7602 66.5 47.6882 66.5 41.5442 66.5H20.4562C14.3122 66.5 11.2402 66.5 8.92657 64.932C8.32499 64.5214 7.7721 64.0437 7.27857 63.508C5.37457 61.4344 4.82417 58.3048 3.72657 52.0488Z",
    stroke: "#D5DEE5",
    strokeWidth: 3.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateDrawer);
export default __webpack_public_path__ + "static/media/emptyStateDrawer.645d167685d2d46b054752b25d93d87b.svg";
export { ForwardRef as ReactComponent };